/**
 * 类型定义文件
 * 定义游戏中使用的所有类型、接口和枚举
 */

/**
 * 位置坐标接口
 */
export interface Position {
  x: number;
  y: number;
}

/**
 * 方块数值类型
 * 限定为2的幂次方，最大到4096
 */
export type TileValue = 2 | 4 | 8 | 16 | 32 | 64 | 128 | 256 | 512 | 1024 | 2048 | 4096;

/**
 * 移动方向枚举
 */
export enum Direction {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
}

/**
 * 游戏状态枚举
 */
export enum GameState {
  Playing = 'playing',
  Won = 'won',
  Over = 'over',
}

/**
 * 游戏配置接口
 */
export interface GameConfig {
  /** 网格大小（默认4） */
  size: number;
  /** 初始方块数量（默认2） */
  startTiles: number;
}

/**
 * 游戏状态数据接口（用于存储）
 */
export interface GameStateData {
  grid: {
    size: number;
    cells: Array<{
      position: Position;
      value: TileValue;
    } | null>;
  };
  score: number;
  over: boolean;
  won: boolean;
}

/**
 * 移动结果接口
 */
export interface MoveResult {
  moved: boolean;
  score: number;
}

/**
 * 键盘事件映射类型
 */
export type KeyboardEventMap = {
  move: Direction;
  restart: void;
};
